export default {
  'app.network.offline':
    'Você está offline no momento. Alguns recursos podem estar indisponíveis.',
  'app.error.chunk.title': 'Falha ao carregar a página',
  'app.error.chunk.description.offline':
    'Sua conexão de rede foi perdida. Verifique sua conexão e atualize a página.',
  'app.error.chunk.description.online':
    'Falha ao carregar os recursos da página. Atualize e tente novamente.',
  'app.error.render.title': 'Algo deu errado',
  'app.error.render.description':
    'Desculpe, ocorreu um erro nesta página. Atualize a página ou volte para a página inicial.',
  'app.error.retry': 'Tentar novamente',
  'app.error.reload': 'Atualizar página',
  'app.error.home': 'Voltar ao Início',
  'app.request.offline':
    'Rede indisponível. Verifique sua conexão e tente novamente.',
};
